import { Navigate } from "react-router-dom";
import { useACL } from "../hooks/useAuth";
import { JSX } from "react";
import { USER_ACL } from "../types/types";
import { Loading } from "../Pages/Loading";
import { Unauth } from "../Pages/Unauth";

type PrivateRouteProps = {
  allowedACLs: USER_ACL[];
  children: JSX.Element;
};

export function PrivateRoute({ allowedACLs, children }: PrivateRouteProps) {
  const { acl, loading, error } = useACL();

  if (loading) return <Loading loadingMessage="Authorizing"/>; 
  if (error) return <Unauth message={error.message} />;

  // Only check ACL if acl exists
  if (acl === null) {
    // Maybe token missing → redirect to login
    return <Navigate to="/login" replace />;
  }

  if (!allowedACLs.includes(acl)) {
    // Logged in but not authorized → redirect elsewhere
    return <Navigate to="/workspace" replace />;
  }

  return children;
}